import { Dialog, Disclosure, Transition } from "@headlessui/react";
import {
  ChevronRightIcon,
  DesktopComputerIcon,
  MenuAlt2Icon,
  MenuIcon,
  XIcon,
} from "@heroicons/react/outline";
import logoImage from "Assets/logo/BotPic2.svg";
import logo from "Assets/logo/light-full-logo.svg";
import { SIDEBAR } from "Component/SideBar";
import { SIDEBARPROFILE } from "Component/SideBar";
import { SidebarRoute } from "Component/SideBar/SidebarRoute";
import { Fragment, useState } from "react";
import { NavLink, Outlet } from "react-router-dom";
import { handleLogout } from "Helper";
import { useNavigate } from "react-router-dom";
import { EncryptStorage } from "encrypt-storage";
import { NAVIGATION } from "Route/ConstantRoute";

function classNames(...classes) {
  return classes.filter(Boolean).join(" ");
}

export function TopBar() {
  const navigate = useNavigate();
  const encryptStorage = new EncryptStorage(process.env.REACT_APP_SECRET_KEY);
  const userInfo = encryptStorage.getItem("___info");
  const permission_flag =
    userInfo?.permission_flag != undefined
      ? JSON.parse(userInfo?.permission_flag)
      : {};
  console.log(userInfo, "userInfo");
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const [hidesideBar, sethidesideBar] = useState(false);
  const [name] = useState(userInfo?.nama || "");
  const [email] = useState(userInfo?.email || "");

  return (
    <div className="h-screen flex overflow-hidden bg-gray-100">
      <Transition.Root show={sidebarOpen} as={Fragment}>
        <Dialog
          as="div"
          className="fixed inset-0 flex z-40 md:hidden"
          onClose={setSidebarOpen}
        >
          <Transition.Child
            as={Fragment}
            enter="transition-opacity ease-linear duration-300"
            enterFrom="opacity-0"
            enterTo="opacity-100"
            leave="transition-opacity ease-linear duration-300"
            leaveFrom="opacity-100"
            leaveTo="opacity-0"
          >
            <Dialog.Overlay className="fixed inset-0 bg-gray-600 bg-opacity-75" />
          </Transition.Child>
          <Transition.Child
            as={Fragment}
            enter="transition ease-in-out duration-300 transform"
            enterFrom="-translate-x-full"
            enterTo="translate-x-0"
            leave="transition ease-in-out duration-300 transform"
            leaveFrom="translate-x-0"
            leaveTo="-translate-x-full"
          >
            <div className="relative flex-1 flex flex-col max-w-xs w-full pt-5 pb-4 bg-white">
              <Transition.Child
                as={Fragment}
                enter="ease-in-out duration-300"
                enterFrom="opacity-0"
                enterTo="opacity-100"
                leave="ease-in-out duration-300"
                leaveFrom="opacity-100"
                leaveTo="opacity-0"
              >
                <div className="absolute top-0 right-0 -mr-12 pt-2">
                  <button
                    type="button"
                    className="ml-1 flex items-center justify-center h-10 w-10 rounded-full focus:outline-none focus:ring-2 focus:ring-inset focus:ring-white"
                    onClick={() => setSidebarOpen(false)}
                  >
                    <span className="sr-only">Close sidebar</span>
                    <XIcon className="h-6 w-6 text-white" aria-hidden="true" />
                  </button>
                </div>
              </Transition.Child>
              <div className="flex-shrink-0 flex items-center px-4">
                <img className="h-10 w-auto" src={process.env.REACT_APP_LOGO_SIDEBAR} alt={process.env.REACT_APP_LOGO_NAME} />
              </div>

              <div className="mt-5 flex-1 h-0 overflow-y-auto">
                <nav className="mt-5 px-2 space-y-1">
                  {SidebarRoute.map((item) =>
                    !item.children ? (
                      <NavLink
                        key={item.name}
                        to={item.href}
                        className={({ isActive }) =>
                          classNames(
                            isActive
                              ? "bg-gray-100 text-gray-900"
                              : "text-gray-900 hover:bg-gray-50",
                            "group w-full flex items-center pl-2 py-2 text-sm font-medium rounded-md"
                          )
                        }
                      >
                        <item.icon
                          className="text-gray-400 mr-3 flex-shrink-0 h-6 w-6"
                          aria-hidden="true"
                        />
                        {item.name}
                      </NavLink>
                    ) : (
                      <Disclosure
                        as="div"
                        key={item.name}
                        className="space-y-1"
                      >
                        {({ open }) => (
                          <>
                            <Disclosure.Button
                              className={classNames(
                                item.current
                                  ? "bg-gray-100 text-gray-900"
                                  : "text-gray-900",
                                "group w-full flex items-center pl-2 pr-1 py-2 text-left text-sm font-medium rounded-md"
                              )}
                            >
                              <item.icon
                                className="text-gray-400 mr-3 flex-shrink-0 h-6 w-6"
                                aria-hidden="true"
                              />
                              <span className="flex-1">{item.name}</span>
                              <svg
                                className={classNames(
                                  open
                                    ? "text-gray-900 rotate-90"
                                    : "text-gray-900",
                                  "ml-3 flex-shrink-0 h-5 w-5 transform group-hover:text-gray-900 transition-colors ease-in-out duration-150"
                                )}
                                viewBox="0 0 20 20"
                                aria-hidden="true"
                              >
                                <path
                                  d="M6 6L14 10L6 14V6Z"
                                  fill="currentColor"
                                />
                              </svg>
                            </Disclosure.Button>
                            <Disclosure.Panel className="space-y-1">
                              {item.children.map((subItem) => (
                                <NavLink
                                  key={subItem.name}
                                  to={subItem.href}
                                  className={({ isActive }) =>
                                    classNames(
                                      isActive
                                        ? "bg-gray-100 text-gray-900"
                                        : "text-gray-900 hover:bg-gray-50",
                                      "group w-full flex items-center pl-11 pr-2 py-2 text-sm font-medium rounded-md"
                                    )
                                  }
                                >
                                  {subItem.name}
                                </NavLink>
                              ))}
                            </Disclosure.Panel>
                          </>
                        )}
                      </Disclosure>
                    )
                  )}
                </nav>
              </div>
              <div className="flex-shrink-0 flex p-4">
                <nav className="mt-5 px-2 space-y-1">
                  {/* <button
                    type="submit"
                    className="gap-2 h-11 flex w-auto justify-center items-center rounded-xl bg-btn-login hover:bg-opacity-50 px-3 py-1.5 text-sm font-semibold leading-6 text-white shadow-sm  focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2"
                  >
                    <DesktopComputerIcon className="h-5 w-auto" />
                    {" MONITORING"}
                  </button> */}

                  <div className="text-gray-900 pb-3">
                    <div className=" flex flex-row items-center gap-2">
                      <button
                        onClick={() => {}}
                        className="shadow-md h-12 flex justify-start items-center text-gray-600 hover:bg-neutral-100 rounded-xl px-3 py-1.5 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2"
                      >
                        <div>
                          <img
                            className="h-6 mr-2 rounded-full"
                            src={logoImage}
                            alt=""
                          />
                        </div>
                        <div className="text-xs">
                          <p className="text-start font-semibold capitalize">
                            {name ? name : "user"}
                          </p>
                          <p>{email ? email : "user@mail.com"}</p>
                        </div>
                      </button>
                    </div>
                  </div>
                  <button
                    type="submit"
                    onClick={() => handleLogout()}
                    className="text-sm h-12 flex w-auto justify-center items-center rounded-xl bg-rose-800 hover:bg-opacity-50 px-3 py-1.5 font-bold leading-6 text-white shadow-lg focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2"
                  >
                    {"Logout"}
                    <ChevronRightIcon className="h-6 w-auto pr-2" />
                  </button>
                </nav>
              </div>
            </div>
          </Transition.Child>
          <div className="flex-shrink-0 w-14" aria-hidden="true">
            {/* Dummy element to force sidebar to shrink to fit close icon */}
          </div>
        </Dialog>
      </Transition.Root>

      {/* Static sidebar for desktop */}
      <div
        className={`${hidesideBar ? "hidden md:hidden" : "hidden md:flex md:flex-shrink-0"}}`}
      >
        <div className="flex flex-col w-64">
          {/* Sidebar component, swap this element with another sidebar if you like */}
          <SIDEBAR sethidesideBar={sethidesideBar} />
        </div>
      </div>

      <div className="flex flex-col w-0 flex-1 overflow-hidden">
        <div className="relative z-10 flex-shrink-0 flex h-16 bg-white shadow-md">
          <button
            type="button"
            className="px-4 border-r border-gray-200 text-gray-500 focus:outline-none focus:ring-2 focus:ring-inset focus:ring-indigo-500 md:hidden"
            onClick={() => setSidebarOpen(true)}
          >
            <span className="sr-only">Open sidebar</span>
            <MenuAlt2Icon className="h-6 w-6" aria-hidden="true" />
          </button>
          <button
            onClick={() => sethidesideBar(false)}
            className={`${hidesideBar ? "hidden md:flex items-center justify-center" : "hidden md:hidden"}}`}
          >
            <MenuIcon className="h-6 w-auto ml-2" aria-hidden="true" />
          </button>

          <div className="flex-1 flex justify-end">
            <div className="hidden md:flex-1 px-4 md:flex justify-between">
              <div className="flex-1 flex" />
              <div className="ml-4 flex items-center md:ml-6">
                <div className="text-gray-900 divide-x divide-gray-300 flex justify-center items-center gap-4">
                  <div className=" flex flex-row items-center gap-4">
                    {permission_flag?.monitoring &&
                    permission_flag?.monitoring === true ? (
                      <button
                        type="submit"
                        onClick={() => {
                          // navigate(NAVIGATION.live_monitoring);
                          window.open(NAVIGATION.live_monitoring, "_blank");
                        }}
                        className="shadow-md text-lg h-12 flex w-auto justify-center items-center rounded-xl bg-cyan-900 hover:bg-opacity-50 px-3 py-1.5 text-sm font-bold leading-6 text-white shadow-lg focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2"
                      >
                        <DesktopComputerIcon className="h-6 w-auto pr-2" />
                        {" EVENT MONITORING"}
                      </button>
                    ) : null}

                    <button
                      onClick={() => {
                        // navigate(NAVIGATION.profile.information);
                      }}
                      className="disabled h-12 flex justify-start items-center text-gray-600 rounded-xl px-3 py-1.5 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2"
                    >
                      <div>
                        <img
                          className="h-8 rounded-full mr-2"
                          src={logoImage}
                          alt=""
                        />
                      </div>
                      <div className="text-xs">
                        <p className="text-start font-semibold capitalize">
                          {name ? name : "user"}
                        </p>
                        <p>{email ? email : "user@mail.com"}</p>
                      </div>
                    </button>
                  </div>
                  <div>
                    <button
                      onClick={() => handleLogout()}
                      className="text-sm h-12 flex items-center mx-4 text-gray-500 hover:bg-zinc-100 rounded-xl px-3 py-1.5 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2"
                    >
                      Logout
                      <ChevronRightIcon className="h-4 w-auto" />
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <main className="flex-1 relative overflow-y-auto focus:outline-none">
          <div className="py-6 w-full h-full">
            <div className="max-w-7xl xl:max-w-full h-full mx-auto px-4 sm:px-6">
              <Outlet />
            </div>
          </div>
        </main>
      </div>
    </div>
  );
}
